import API from "src/api/base";


class Requester extends API {
  PATH = "users/";

  async getPermissions() {
    try {
      const response = await this.get({
        url: `custom/get-permissions/`,
      });
      return response;
    } catch (err) {
      return err;
    }
  }
}

const UserAPI = new Requester();

export default UserAPI;